import { Knowledge } from '@getmayday/vue-modules';

export const computeNavigationLanguage = (
  knowledge: Knowledge,
  contentLanguage: string | undefined,
  fallbackLanguage?: string,
) => {
  const hasContentLanguage =
    contentLanguage && knowledge?.supportedLanguages?.includes(contentLanguage);

  return hasContentLanguage ? contentLanguage : fallbackLanguage;
};
